import { Event } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { EventClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export const eventByIdQueryKey = (eventId: number) =>
  [queryKeys.events.root, 'byId', eventId] as const;

export const useEventByIdQuery = ({
  eventId,
  enabled = true,
}: {
  eventId: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: eventByIdQueryKey(eventId),
    queryFn: () => EventClientService.Get(Event.create({ id: eventId })),
    enabled: enabled && eventId > 0,
  });
};
